import React from 'react';
import {
    Button, AnchorButton,
    Tab, Tabs,
    ButtonGroup,
    Icon,
    EditableText,
    Toaster, Alert, Overlay, Popover, Tooltip, Card,
    Intent, Position, Classes, Elevation, Dialog, InputGroup, FormGroup
} from "@blueprintjs/core";
import NdbkAPI from '../ndbk-api'

export default class LoginForm extends React.Component {
    state = {
        showPassword: false,
        usernameEmailInput: "",
        passwordInput: "",
        showError: false,
        doRedirect: false
    }

    loginHandler = () => {
        NdbkAPI.auth.login({
            username: this.state.usernameEmailInput,
            password: this.state.passwordInput
        }, ()=>{
            this.props.auth.checkAuth(()=>{
                this.props.history.push('/')
            })
        }, ()=>{
            this.setState({
                showError: true,
                passwordInput: ""
            })
        })
    }

    toggleShowPassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    onUsernameEmailChange = (e) => {
        this.setState({
            usernameEmailInput: e.target.value,
            showError: false
        })
    }

    onPasswordChange = (e) => {
        this.setState({
            passwordInput: e.target.value,
            showError: false
        })
    }

    onKeyUp = (e) => {
        if (e.key === "Enter" && this.state.usernameEmailInput !== "" && this.state.passwordInput !== "") {
            this.loginHandler()
        }
    }

    render() {

        const lockButton = (
            <Tooltip content={`${this.state.showPassword ? "Hide" : "Show"} Password`} position="right">
                <Button
                    icon={this.state.showPassword ? "eye-open" : "eye-off"}
                    minimal
                    onClick={this.toggleShowPassword}
                />
            </Tooltip>
        );

        return (
            <div className="landing-registration" onKeyUp={e=>{
                if (e.key==="Enter") {
                    this.loginHandler()
                }
            }}>
                <div className="auth">
                    <AnchorButton
                        href="https://nodebook.io/api/auth/google"
                        text="Sign in with Google"
                        intent="danger"
                        className="auth-button"
                    />
                    <AnchorButton
                        href="https://nodebook.io/api/auth/twitter"
                        text="Sign in with Twitter"
                        intent="primary"
                        className="auth-button"
                    />
                </div>
                <div className="new">
                    <hr/>
                    <InputGroup
                        id="username"
                        large
                        placeholder="Username or email"
                        leftIcon="person"
                        autoComplete="false"
                        value={this.state.usernameEmailInput}
                        onChange={this.onUsernameEmailChange}
                        onKeyUp={this.onKeyUp}
                        spellCheck={false}
                        autoFocus={true}
                    />
                    <InputGroup
                        id="password"
                        large
                        placeholder="Password"
                        leftIcon="lock"
                        rightElement={lockButton}
                        type={this.state.showPassword ? "text" : "password"}
                        value={this.state.passwordInput}
                        onChange={this.onPasswordChange}
                        onKeyUp={this.onKeyUp}
                        spellCheck={false}
                    />
                    <div style={{float: "right"}}>
                        <Tooltip content="Incorrect login information." position="right" intent="danger" isOpen={this.state.showError}>
                            <Button
                                text="Login"
                                rightIcon="log-in"
                                intent="primary"
                                style={{marginLeft: "10px"}}
                                onClick={this.loginHandler}
                            />
                        </Tooltip>
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginForm.js